/**
 * Residency period helpers.
 * Current fellows go in the right column; finished ones in the main Residents list.
 */

export function residencyStartMs (profile) {
  return Number(profile && profile.residencyStart) || 0
}

export function residencyEndMs (profile) {
  return Number(profile && profile.residencyEnd) || 0
}

/**
 * Active residency: started, and no end date or end date still ahead.
 */
export function isCurrentResidency (profile, now = Date.now()) {
  const start = residencyStartMs(profile)
  const end = residencyEndMs(profile)
  if (!start || start > now) return false
  if (!end) return true
  return end >= now
}

/**
 * Finished residency: has an end date that is already past.
 * Mutually exclusive with isCurrentResidency.
 */
export function isPastResidency (profile, now = Date.now()) {
  if (isCurrentResidency(profile, now)) return false
  const start = residencyStartMs(profile)
  const end = residencyEndMs(profile)
  return !!start && !!end && end < now
}
